import AxiosInstance from "./api";

export const InvestmentDifferenceAllocationRegisterService = {
  paginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/investment-difference-allocation-register/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/investment-difference-allocation-register/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/investment-difference-allocation-register", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/investment-difference-allocation-register/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/investment-difference-allocation-register/" + id);
  },
};
